import { useContext } from 'react'

import {
  Box,
  Button,
  Icon,
  Text,
  getThemeColor,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ProviderContext } from '../../provider.context'

import * as Styles from './provider-certificates-card.styles'

export const ProviderCertificatesCard = () => {
  const theme = useTheme()
  const { certificates, actions } = useContext(ProviderContext)

  const hasCertificates = (certificates?.length ?? 0) > 0

  const translateStatus = (status?: string) => {
    switch (status) {
      case 'certified':
        return 'Válido'
      case 'inactive':
        return 'Inativo'
      case 'expired':
        return 'Expirado'
      default:
        return status || '-'
    }
  }

  const statusColor = (status?: string) => {
    switch (status) {
      case 'certified':
        return getThemeColor('success', theme)
      case 'inactive':
        return getThemeColor('grey_3', theme)
      case 'expired':
        return getThemeColor('warning', theme)
      default:
        return getThemeColor('grey_3', theme)
    }
  }

  return (
    <Styles.Container
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={2}
      direction="column"
      flex={1}
      minWidth="290px"
    >
      <Box width="100%" justifyContent="space-between" alignItems="center">
        <Box gap={1} alignItems="center">
          <Icon name="shield_check" color="grey_2" size={20} />
          <Text size="small" fontWeight={500} color="grey_2">
            Certificados
          </Text>
        </Box>
        <a href="#tabs">
          <Button
            variant="outlined"
            width="100%"
            fontSize="small"
            padding="8px"
            onClick={() => actions.setActiveTab('Certificados')}
          >
            <Icon name="arrow_right_up" color="grey_2" size={16} />
          </Button>
        </a>
      </Box>
      {hasCertificates ? (
        <Box width="100%" direction="column" gap={2}>
          {certificates?.map((cert, idx) => (
            <Styles.Certificate
              key={idx}
              direction="column"
              gap={2}
              status={cert.status}
            >
              <Box
                width="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box gap={1} alignItems="center">
                  <Text color="grey_1" fontWeight={600}>
                    {(cert.type || '').toUpperCase()}
                  </Text>
                </Box>
                <Box gap={1} alignItems="center">
                  <Text color="grey_1">{translateStatus(cert.status)}</Text>
                  <Icon
                    name={
                      cert.status === 'certified' ? 'shield_check' : 'alert'
                    }
                    color={statusColor(cert.status)}
                    size={20}
                  />
                </Box>
              </Box>
              <Box>
                {cert.expiresAt && (
                  <Box gap={1}>
                    <Text color="grey_2" size="12px">
                      Vencimento:
                    </Text>
                    <Text color="grey_1" size="12px">
                      {new Date(cert.expiresAt).toLocaleDateString()}
                    </Text>
                  </Box>
                )}
              </Box>
            </Styles.Certificate>
          ))}
        </Box>
      ) : (
        <Box width="100%" justifyContent="center" paddingY={3}>
          <Text align="center">Nenhum certificado encontrado</Text>
        </Box>
      )}
    </Styles.Container>
  )
}
